import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import IosShareIcon from '@mui/icons-material/IosShare';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import Setting from '../assets/icons/stetting.svg';
import Iesercizi from '../assets/icons/esercizi.svg';
import Iprogrammi from '../assets/icons/programmi.svg';
import Isessioni from '../assets/icons/sessioni.svg';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

import fuoco from '../assets/icons/fire.svg';
import clessidra from '../assets/icons/clessidra.svg';
import orologio from '../assets/icons/orologio.svg';

import SearchIcon from "@mui/icons-material/Search";

import { Sessione, SessioneVuoto } from '../interfaces/Sessione';
import { Esercizio, THead } from '../interfaces/Esercizio';

import MiniCard2 from '../components/MiniCard2';
import ListPanel from '../components/ListPanel';
import ParametriSessionePanel from '../components/ParametriSessionePanel';
import { MODALTYPE, ModalData, modalDataClean, ModalAlert } from '../components/ModalAlert';
import { formatTime } from "../utils/utils";
import SpinnerODM from '../components/spinnerODM';
import { Height } from '@mui/icons-material';
import eserciziB from '../assets/icons/eserciziB.svg';
import ODMTable from '../components/ODMTable';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import MasterHeader from '../components/MasterHeder';

//interface SessionePageProps {
//  token: string;
//}


const SessionePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [sessione, setSessione] = useState<Sessione>(SessioneVuoto);
  const [sessioni, setSessioni] = useState<Sessione[]>([]);
  const [esercizi, setEsercizi] = useState<Esercizio[]>([]);
  const [eserciziNellaSessione, setEserciziNellaSessione] = useState<Esercizio[]>([]);
  const [querySessioni, setQuerySessioni] = useState("");
  const [queryEsercizi, setQueryEsercizi] = useState("");
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState<string | null>(null);
  const [modalData, setModalData] = useState<ModalData>(modalDataClean);
  const [selectedSessioneId, setSelectedSessioneId] = useState<number | null>(null);
  const [eserciziFiltrati, setEserciziFiltrati] = useState<Esercizio[]>([]);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);

  const iconProgrammi = <img src={Iprogrammi} alt="icon" width={30} />
  const iconSessioni = <img src={Isessioni} alt="icon" width={30} />
  const iconEsercizio = <img src={eserciziB} alt="icon" width={30} />

  const iconFuoco = <img src={fuoco} alt="icon" width={20} />
  const iconClessidra = <img src={clessidra} alt="icon" width={20} />
  const iconOrologio = <img src={orologio} alt="icon" width={20} />

  const cards = [
    { name: "Complessità gestione gravitativa", value: Number(sessione.gravity_management_complexity).toFixed(1), icon: "", color: "#228822" },
    { name: "Complessità coordinazione motoria", value: Number(sessione.motor_coordination_complexity).toFixed(1), icon: "", color: "#228822" },
    { name: "Intensità cardio-respiratoria", value: Number(sessione.cardiorespiratory_complexity).toFixed(1), icon: "", color: "#228822" },
    { name: "Tempo attivo", value: formatTime(sessione.active_time * eserciziNellaSessione.length * sessione.repetitions), icon: iconFuoco, color: "#333" },
    { name: "Tempo di recupero", value: formatTime(sessione.recovery_time * eserciziNellaSessione.length * sessione.repetitions), icon: iconClessidra, color: "#333" },
    { name: "Tempo totale", value: formatTime((sessione.active_time + sessione.recovery_time) * eserciziNellaSessione.length * sessione.repetitions), icon: iconOrologio, color: "#333" },
  ];

  useEffect(() => {
    const mean_gravity_management_complexity = eserciziNellaSessione.length > 0
      ? eserciziNellaSessione.reduce((acc, curr) => acc + curr.gravity_management_complexity, 0) / eserciziNellaSessione.length
      : 0;
    const mean_motor_coordination_complexity = eserciziNellaSessione.length > 0
      ? eserciziNellaSessione.reduce((acc, curr) => acc + curr.motor_coordination_complexity, 0) / eserciziNellaSessione.length
      : 0;
    const mean_cardiorespiratory_complexity = eserciziNellaSessione.length > 0
      ? eserciziNellaSessione.reduce((acc, curr) => acc + curr.cardiorespiratory_complexity, 0) / eserciziNellaSessione.length
      : 0;

    setSessione(prev => ({ ...prev, 
      ['gravity_management_complexity']: Math.round(mean_gravity_management_complexity * 10) / 10, 
      ['motor_coordination_complexity']: Math.round(mean_motor_coordination_complexity * 10) / 10,
      ['cardiorespiratory_complexity']: Math.round(mean_cardiorespiratory_complexity * 10) / 10, 
    }));
  }, [eserciziNellaSessione])

  useEffect(() => {
    setLoading(true);
    const headers = new Headers();
    //if (token) {
    //  headers.set('Authorization', `Token ${token}`);
    //}
    headers.set('Accept', 'application/json');
    const requestInit: RequestInit = {
      method: 'GET',
      headers: headers,
      credentials: 'include',
    }
    fetch("/api/v0/activities?type=Exercise", requestInit)
      .then(res => res.json())
      .then((data: Esercizio[]) => setEsercizi(data))
      .catch(err => setErrore("Errore nel recupero esercizi"))
      .finally(() => setLoading(false));
  }, []);

  const fetchSessoni = async () => {
    try {
      const headers = new Headers();
      //if (token) {
      //  headers.set('Authorization', `Token ${token}`);
      //}
      headers.set('Accept', 'application/json');
      const requestInit: RequestInit = {
        method: 'GET',
        headers: headers,
        credentials: 'include',
      }
      const response = await fetch('/api/v0/sessions', requestInit);
      if (!response.ok) throw new Error('Errore nel recupero delle attività');
      const data = await response.json();
      setSessioni(data);
    } catch (err: any) {
      setErrore(err.message);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchSessoni()
  }, []);


  useEffect(() => {
    setLoading(true);
    const handle_id = async (id: string) => {
      try {
        const headers = new Headers();
        //if (token) {
        //  headers.set('Authorization', `Token ${token}`);
        //}
        headers.set('Accept', 'application/json');
        const requestInit: RequestInit = {
          method: 'GET',
          headers: headers,
          credentials: 'include',
        }
        const res = await fetch(`/api/v0/session/${id}`, requestInit);
        const data = await res.json();
        setSessione(data);

      } catch (err) {
        console.error("Errore nel recupero della sessione:", err);
      }
    };
    if (id) {
      handle_id(id);
    }
    setLoading(false)
  }, [id]);


  useEffect(() => {
    if (sessione != null && sessione.id != null && esercizi != null && esercizi.length > 0 && eserciziNellaSessione != null && eserciziNellaSessione.length == 0) {
      const data: Esercizio[] = []
      sessione.activities.forEach((act_id) => {
        data.push(findEsercizio(act_id));
      })
      if (data.length > 0) {
        setEserciziNellaSessione(data)
      }
      sessione.activities = []
    }
  }, [sessione, esercizi]);


  const handleChange = <K extends keyof Sessione>(key: K, value: Sessione[K]) => {
    setSessione(prev => ({ ...prev, [key]: value }));
  };

  const salvaSessione = async (dati: Sessione) => {
    if (!isValidSessione("salva")) {
      setModalData({
        show: true,
        title: "",
        message: "Specificare un nome e una descrizione",
        type: MODALTYPE.OK,
      })
    } else {
      setLoading(true);
      const activities: number[] = [];
      eserciziNellaSessione.forEach(esercizio => {
        activities.push(esercizio.id!);
      });
      dati.activities = activities;
      try {
        const url = id ? `/api/v0/session/${id}` : '/api/v0/session/new';
        const method = id ? 'PUT' : 'POST';

        const headers = new Headers();
        //if (token) {
        //  headers.set('Authorization', `Token ${token}`);
        //}
        headers.set('Content-Type', 'application/json');
        const requestInit: RequestInit = {
          method,
          headers: headers,
          body: JSON.stringify(dati),
          credentials: 'include',
        }
        const response = await fetch(url, requestInit);

        if (!response.ok) {
          const errorData = await response.json();
          const messages = Object.entries(errorData)
            .map(([field, errors]) => `${field}: ${Array.isArray(errors) ? errors.join(', ') : errors}`)
            .join('\n');
          throw new Error(messages);
        }

        const data = await response.json();
        setSessione(data);
        navigate('/sessioni');
      } catch (error: any) {
        console.error("Errore durante il salvataggio:", error);
        setModalData({
          show: true,
          title: "",
          message: error.message || "Errore durante il salvataggio dell'esercizio",
          type: MODALTYPE.OK,
        })
      }
      setLoading(false);
    }
  };

  const salva = () => {
    salvaSessione(sessione);
  };


  const eliminaSessione = async () => {
    setLoading(true)
    if (!id) return;
    try {
      const headers = new Headers();
      //if (token) {
      //  headers.set('Authorization', `Token ${token}`);
      //}
      const response = await fetch(`/api/v0/session/${id}`, {
        method: "DELETE",
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error("Errore durante l'eliminazione della sessione");
      }
      navigate("/sessioni");
    } catch (error: any) {
      console.error("Errore durante la chiamata DELETE:", error);
      setModalData({
        show: true,
        title: "",
        message: error.message || "Si è verificato un errore durante l'eliminazione dell'esercizio",
        type: MODALTYPE.OK,
      })
    }
    setLoading(false)
  };

  const aggiornaPubblicazione = () => {
    const nuovoStatus = sessione.status === "Published" ? (isValidSessione("pubblica") ? "Publishable" : "Draft") : "Published";
    salvaSessione({ ...sessione, status: nuovoStatus });
  };

  useEffect(() => {
    setEserciziFiltrati(selectedSessioneId && esercizi ?
      esercizi.filter((e) => sessioni.find(s => s.id === selectedSessioneId)?.activities.includes(e.id!))
      : esercizi.filter((e) => 
        e.full_name.toLowerCase().includes(queryEsercizi.toLowerCase())
        ||
        e.position.toLowerCase().includes(queryEsercizi.toLowerCase())
      ))
  }, [esercizi, sessioni, selectedSessioneId, queryEsercizi]);

  const aggiungiEsercizio = (esercizio: Esercizio) => {
    setEserciziNellaSessione(prev => {
      // if (prev.find(e => e.id === esercizio.id)) return prev;
      return [...prev, esercizio];
    });
  };

  const rimuoviEsercizio = (idxToRemove: number) => {
    setEserciziNellaSessione(prev => prev.filter((item, idx) => idx != idxToRemove))
  };

  const svuotaEsercizi = () => {
    setEserciziNellaSessione([])
  };

  const findEsercizio = (act_id: number) => {
    return esercizi.find(el => el.id === act_id)!;
  }

  const elimina = () => {
    const deleteSession = async () => {
      await eliminaSessione();
    }
    setModalData({
      show: true,
      title: "Elimina elemento",
      message: "Se decidi di procedere, questo elemento verrà eliminato definitivamente dal backoffice.",
      type: MODALTYPE.DELETE,
      action: deleteSession
    })
  }


  const isValidSessione = (type: string) => {
    const baseValidation = sessione.name?.trim() && sessione.description?.trim();
    const eserciziValidation = eserciziNellaSessione.length >= 2;
    const timeValidation = sessione.active_time > 0 && sessione.recovery_time > 0;

    if (type === "salva") {
      return baseValidation && timeValidation && (sessione.status !== "Published" || eserciziValidation);
    }

    if (type === "pubblica") {
      return baseValidation && timeValidation && eserciziValidation;
    }

    return false;
  };

  const closeModal = () => setModalData(prev => ({ ...prev, show: false }));

  const statoBadge = sessione.status === "Published"
    ? <span className="badge text-bg-success">Pubblicato</span>
    : <span className="badge text-bg-danger">Non pubblicato</span>;

  if (loading) {
    return (
      <SpinnerODM />
    )
  }

  const reorderItems = (draggedId: string, targetId: string) => {
    const draggedIndex = eserciziNellaSessione.findIndex(
      (item) => String(item.id) === draggedId
    );
    const targetIndex = eserciziNellaSessione.findIndex(
      (item) => String(item.id) === targetId
    );

    if (draggedIndex === -1 || targetIndex === -1) return eserciziNellaSessione;
    const newOrder = [...eserciziNellaSessione];
    const [draggedItem] = newOrder.splice(draggedIndex, 1);
    newOrder.splice(targetIndex, 0, draggedItem);

    return newOrder;
  };

  const reorderItems2 = (draggedIndex: number, targetIndex: number) => {
    console.log(draggedIndex)
    console.log(targetIndex)
    if (draggedIndex === -1 || targetIndex === -1) return eserciziNellaSessione;
    const newOrder = [...eserciziNellaSessione];
    const [draggedItem] = newOrder.splice(draggedIndex, 1);
    newOrder.splice(targetIndex, 0, draggedItem);

    return newOrder;
  };

  return (
    <Box sx={{ display: "flex", height: "100%", width: "100%" }}>
      <Box
        component="section"
        sx={{
          flexGrow: 1,
          height: "100%",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <MasterHeader
          tipo={"sessione"}
          statoBadge={statoBadge}
          elimina={elimina}
          nomeElemento={id == null ? "Nuovo Elemento" : sessione.name}
          salvaModifica={salva}
          aggiornaPubblicazione={aggiornaPubblicazione}
          status={sessione.status}
          stateSave={!isValidSessione("salva")}
          statePublished={sessione.status !== "Published" && !isValidSessione("pubblica")}
          deleteDisabled={sessione.id==null}
        />
        <div className="pt-5 ps-5 pe-5 backgroundPage" style={{ height: "calc(100% - 165px)", overflowY: "auto", margin: 0 }}>
          <div className="row">
            <div className="col-4">
              <div className='d-flex mb-2'><img src={Setting} alt="icon" width={24} /><h5 className='ms-2'>Parametri sessione</h5></div>
              <div className="white-panel p-3" style={{ height: 350, overflowY: "auto" }}>
                <ParametriSessionePanel sessione={sessione} handleChange={handleChange} />
              </div>
            </div>
            <div className="col-8">
              <div className='d-flex mb-2'><SearchIcon /><h5 className='ms-2'>Anteprima sessione</h5></div>
              <div className="white-panel p-3" style={{ height: "350px" }}>
                <h3 className='mb-5'>{sessione.name ? sessione.name : "Nuova sessione"}</h3>
                <div className="row row-cols-3 g-2">
                  {cards.map((card, idx) => <div className="col" key={idx}><MiniCard2 {...card} /></div>)}
                </div>
              </div>
            </div>
          </div>

            <div className='row pt-4' style={{ height: "100%" }}>
              {/* Colonna sinistra: Sessioni */}
              <div className='col-12 col-md-3 col-lg-2 mb-5' style={{ height: "100%" }}>
                <div className='d-flex justify-content-between mb-2' style={{ height: "40px" }}></div>
                <div className="rounded-3 border overflow-hidden bg-white" style={{ height: "100%", overflowY: "auto", minWidth: 220 }}>
                  <div className="d-flex align-items-center gap-2 px-3 py-2" style={{ padding: "8px 12px", height: "30px" }}>
                    <div>{iconSessioni}</div>
                    <h6 className="m-0">Sessioni</h6>
                  </div>

                  <div className="m-2" style={{ height: "30px" }}>
                    <input
                      type="text"
                      placeholder={"Cerca una sessione"}
                      className="form-control"
                      value={querySessioni}
                      onChange={(e) => setQuerySessioni(e.target.value)}
                    />
                  </div>

                  <div className='m-2' style={{ height: "calc(100% - 80px)", overflowY: "auto" }}>
                    <div
                      key={"nessunasessione"}
                      className="p-2 border rounded bg-white mt-1"
                      draggable
                      onClick={() => setSelectedSessioneId(null)}
                      onDragStart={(e) => {}}
                      style={{ cursor: "pointer" }}
                    >
                      Nessuna sessione
                    </div>
                    {loading ? <p>Caricamento...</p> :
                      sessioni.map((item) => (
                        <div
                          key={item.id}
                          className="p-2 border rounded bg-white mt-1 tagline"
                          draggable
                          onClick={() => setSelectedSessioneId(item.id!)}
                          onDragStart={(e) => e.dataTransfer.setData("application/json", JSON.stringify(item))}
                          style={{ cursor: "pointer" }}
                        >
                          {item.name}
                        </div>
                      ))
                    }
                    {errore && <div className="text-danger">{errore}</div>}
                  </div>
                </div>
              </div>

              {/* Colonna centrale: Esercizi */}
              <div className='col-12 col-md-5 col-lg-7' style={{ height: "100%" }}>
                <div className='d-flex justify-content-between mb-2' style={{ height: "40px" }} />
                <div className="rounded-3 border overflow-hidden bg-white" style={{ height: "100%", minWidth: 220 }}>
                  <div
                    className="d-flex align-items-center gap-2 px-3 py-2"
                    style={{ backgroundColor: "black", color: "white", padding: "8px 12px", height: "30px" }}
                  >
                    {iconEsercizio}
                    <h6 className="m-0">Esercizi</h6>
                  </div>
                  <div className="m-2" style={{ height: "40px" }}>
                    <input
                      type="text"
                      placeholder={"Cerca..."}
                      className="form-control"
                      value={queryEsercizi}
                      onChange={(e) => setQueryEsercizi(e.target.value)}
                    />
                  </div>

                  <div className="m-2" style={{ height: "100%" }}>
                    {loading ? (
                      <p>Caricamento...</p>
                    ) : (
                      <div style={{ minWidth: "500px", height: "100%" }}>
                        <ODMTable
                          columns={THead}
                          rows={eserciziFiltrati}
                          navTable="esercizi"
                          onRowClick={(row) => aggiungiEsercizio(findEsercizio(row.id))}
                          draggableRows={true}
                          onDragStart={(row, e) => {
                            e.dataTransfer.setData("application/json", JSON.stringify(row));
                          }}
                          stickyColumnIds={["full_name",]}
                          heightTable='calc(100% - 90px)'
                          edit={true}
                        />
                      </div>
                    )}
                    {errore && <div className="text-danger">{errore}</div>}
                  </div>
                </div>
              </div>

              {/* Colonna destra: Carrello */}
              <div className='col-12 col-md-4 col-lg-3' style={{ height: "100%" }}>
                <div className='d-flex justify-content-between mb-2' style={{ height: "40px" }}>
                  <button className='btn btn-secondary' onClick={svuotaEsercizi}>Svuota</button>
                </div>

                <div className="rounded-3 border overflow-hidden bg-white" style={{ height: "100%", minWidth: 220 }}>
                  <div className="d-flex align-items-center gap-2 px-3 py-2" style={{ backgroundColor: "#1C492D", color: "white", padding: "8px 12px", height: "30px" }}>
                    <ShoppingCartIcon />
                    <h6 className="m-0 tagline">{sessione.name ? sessione.name : "Nuova sessione"}</h6>
                  </div>

                  <div
                    className="scrollable-panel"
                    style={{ height: "90%", overflowY: "auto" }}
                  >
                    {loading || eserciziNellaSessione.length === 0 ? (
                      <div className="text-muted p-3">Trascina qui gli esercizi...</div>
                    ) : (
                      <ul className="list-group list-group-flush">
                        {eserciziNellaSessione.map((item, idx) => (
                          <li
                            key={`sesex_${idx}`}
                            id={String(idx)}
                            className={`${dragOverIndex === idx ? 'highlight-drop-position' : ''} list-group-item d-flex justify-content-between`}
                            draggable
                            onDragStart={(e) => e.dataTransfer.setData("text/plain", String(idx))}
                            onDragOver={(e) => {
                              e.preventDefault()
                              //console.log("idx: " + idx)
                              setDragOverIndex(idx)
                            }}
                            onDragLeave={() => {
                              setDragOverIndex(null);
                            }}
                            onDrop={(e) => {
                              e.preventDefault();
                              /*
                              const draggedId = e.dataTransfer.getData("text/plain");
                              const target = e.target as HTMLElement;
                              //console.log(draggedId)
                              //console.log(target)
                              //console.log(target.parentElement)
                              if (draggedId && target) {
                                let targetId = null;
                                if (target.tagName === "LI" && target.id) {
                                  targetId = target.id;
                                }
                                else if (target.parentElement?.tagName === "LI" && target.parentElement?.id) {
                                  targetId = target.parentElement?.id;
                                }
                                else if (target.parentElement?.parentElement?.tagName === "LI" && target.parentElement?.parentElement?.id) {
                                  targetId = target.parentElement?.parentElement?.id;
                                }
                                if (targetId != null) {
                                  //console.log(targetId)
                                  const newOrder = reorderItems(draggedId, targetId);
                                  setEserciziNellaSessione(newOrder);
                                }
                              }
                              */
                              const draggedId = parseInt(e.dataTransfer.getData("text/plain"));
                              const newOrder = reorderItems2(draggedId, idx);
                              setEserciziNellaSessione(newOrder);
                              setDragOverIndex(null);
                            }}
                          >
                            <div   style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                width: "100%",
                              }}>
                              <DragIndicatorIcon style={{ flexShrink: 0 }} />
                              <span style={{
                                  flex: 1,
                                  minWidth: 0,          // fondamentale per far funzionare truncate
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                }}>
                                {item.full_name}
                              </span>
                              <button
                                style={{ flexShrink: 0 }}
                                className="btn btn-sm btn-light"
                                onClick={() => rimuoviEsercizio(idx)}
                              >
                                ✕
                              </button>
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

            <div className='row pt-4' style={{ height: "10px" }}>
            </div>
            </div>
        </div>
        <ModalAlert
          modalData={modalData}
          onClose={closeModal} />
      </Box >
    </Box >
  );
};

export default SessionePage;
